import { Component, OnInit, ChangeDetectionStrategy, Input, HostBinding, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { createAction, props, Store } from '@ngrx/store';
import { DataService } from '../form-core/data/data.service';
import { ScrollService } from '../step/scroll.service';

export const backToAction = createAction(
  '[Review Component] Back To Review Step',
  props<{ step: string }>()
)

@Component({
  selector: 'div[data-component-type=review]',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewComponent implements OnInit {

  @Input() label!: string
  @Input() value!: any
  @Input() url!: string
  @Input() path!: string
  @Input() editable: boolean = true

  @Input() @HostBinding('class') position!: "left" | "right" | "fullwidth"
  @HostBinding('class.touch') touchDevice: boolean
  @HostBinding('class.hover') hover: boolean = false

  @HostListener('mouseenter') enter() {
    if (this.editable) this.hover = true
  }

  @HostListener('mouseleave') leave() {
    this.hover = false
  }


  @HostListener('mousedown') goToEdit() {
    if (this.editable) {
      this.router.navigate([this.url])
      this.store.dispatch(backToAction({step: location.pathname}))
      this.scroll.scrollToEdit.next(this.path)
    }
  }

  constructor(data: DataService, private scroll: ScrollService, private router: Router, private store: Store) {
    this.touchDevice = data.device.device?.type === 'smartphone' || data.device.device?.type === 'tablet'
  }

  ngOnInit(): void {
  }

}

export interface ReviewOptions {
  id: string,
  type: 'review-component',
  label: string,
  value: any,
  url: string,
  path: string,
  presence: boolean,
  position: 'fullwidth' | 'left' | 'right',
  editable?: boolean
}